import React, { useState, useEffect, useCallback, useRef } from 'react';

import { SearchInput, useT } from '@repo/common';
import { searchSkills } from '../../../../../api/career/career.api';
import SelectedSkills from './SelectedSkills';
import PopularSkills from './PopularSkills';
import SearchSkillsList from './SearchSkillsList';

const SkillsContent = ({ skill, setResumeData }) => {
  const t = useT();
  const [keyword, setKeyword] = useState('');
  const [results, setResults] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState(skill);
  const [isFocused, setIsFocused] = useState(false);
  const [showPopular, setShowPopular] = useState(true);

  const wrapperRef = useRef(null);

  const handleSearch = useCallback(async () => {
    if (!keyword.trim()) {
      setResults([]);
      return;
    }

    const data = await searchSkills(keyword);
    setResults(data.slice(0, 20));
  }, [keyword]);

  const toggleSkill = (skill) => {
    setSelectedSkills((prev) =>
      prev.includes(skill) ? prev.filter((s) => s !== skill) : [...prev, skill]
    );
  };

  const removeSkill = (skillName) => {
    setSelectedSkills(selectedSkills.filter((s) => s !== skillName));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleSearch();
    }, 300);
    return () => clearTimeout(timer);
  }, [handleSearch, keyword]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsFocused(false);
      }
    };

    if (isFocused) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isFocused]);

  useEffect(() => {
    setResumeData((prev) => ({
      ...prev,
      skill: selectedSkills,
    }));
  }, [selectedSkills, setResumeData]);

  return (
    <div className='flex flex-col items-start w-full min-w-[460px] max-w-[950px] gap-6'>
      <div>
        <SelectedSkills selected={selectedSkills} onRemove={removeSkill} />
      </div>

      <div ref={wrapperRef} className='w-full relative'>
        <SearchInput
          value={keyword}
          placeholder={t(
            'Search and add skills (e.g. Project Management)',
            '스킬을 검색해 추가해 주세요 (예: Project Management)'
          )}
          activePlaceholder={t(
            'Search and add skills (e.g. Project Management)',
            '스킬을 검색해 추가해 주세요 (예: Project Management)'
          )}
          onChange={(v) => setKeyword(v)}
          onEnter={handleSearch}
          onFocus={() => setIsFocused(true)}
        />

        {isFocused && (
          <SearchSkillsList
            results={results}
            keyword={keyword}
            selected={selectedSkills}
            onToggle={toggleSkill}
          />
        )}
      </div>

      <div className='w-full'>
        {showPopular && (
          <PopularSkills
            selected={selectedSkills}
            onSelect={toggleSkill}
            onClose={() => setShowPopular(false)}
          />
        )}
      </div>
    </div>
  );
};

export default SkillsContent;
